import * as _ from 'lodash';
import Vue from 'vue';

export interface ITjipBusyPromise {
  value?: Promise<void>;
}

class TjipBusyService {
  private allPromises: { [key: string]: Promise<any>[] } = {};
  private keyPromises: { [key: string]: ITjipBusyPromise } = {};
  private keyResolves: { [key: string]: (value: void | Promise<void>) => void } = {};
  private nextId = 1;

  add<T extends Promise<any>>(promise: T, key?: string): T {
    const k = key || 'busy';
    const promises = (this.allPromises[k] = this.allPromises[k] || []);
    const keyPromise = this.keyPromise(k);
    if (!keyPromise.value) {
      keyPromise.value = new Promise(resolve => {
        this.keyResolves[k] = resolve;
      });
    }

    const promiseFinished = (id: number, promise: T, rejected = false) => {
      const ndx = _.indexOf(promises, promise);
      if (ndx >= 0) {
        promises.splice(ndx, 1);
        Vue.$log.debug(`promise ${k} #${id} ${rejected ? 'rejected' : 'resolved'}, ${promises.length} remaining`);
      }

      if (!promises.length) {
        Vue.$log.debug(`promise ${k} all resolved`);
        this.keyResolves[k]();
        delete this.keyResolves[k];
        keyPromise.value = undefined;
      }
    };

    if (_.indexOf(promises, promise) < 0) {
      const id = this.nextId++;
      promises.push(promise);
      Vue.$log.debug(`promise ${k} #${id} added, ${promises.length} remaining`);

      promise
        .then(() => {
          promiseFinished(id, promise);
        })
        .catch((err: Error) => {
          promiseFinished(id, promise, true);
          throw err;
        });
    }

    return promise;
  }

  promise(key?: string): ITjipBusyPromise {
    const k = key || 'busy';
    return this.keyPromise(k);
  }

  private keyPromise(key: string): ITjipBusyPromise {
    // mimic vue 3 composition ref
    const result = (this.keyPromises[key] = this.keyPromises[key] || Vue.observable({ value: undefined }));
    return result;
  }
}

export const tjipBusyService = new TjipBusyService();
